import TablePagination from '@mui/material/TablePagination';

export default TablePagination;
